import { render } from "./AppearanceRange.vue?vue&type=template&id=4b23d0e2"
import script from "./AppearanceRange.vue?vue&type=script&lang=js"
export * from "./AppearanceRange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__